<style lang="scss" scoped="">
  .el-row {
    margin-bottom: 10px;
  }
  .base-pic-list {
    display: flex;
    flex-wrap: wrap;
    .base-pic-item {
      border: 1px solid #eee;
      position: relative;
      cursor: pointer;
      width: 180px;
      margin: 5px;
      padding: 10px;
      font-size: 12px;

      img {
        width: 180px;
        height: 180px;
        display: block;
        background: #ccc;

      }

    }
  }

</style>
<template>
  <dialog-template :pageSets="pageSets" @selectTab="selectTab">】
    <template slot="title">单位信息</template>
    <template slot="btn">
      <perm :label="'code-org-autonomously-audit'" v-show="data.orgAuditStatus==='0'">
        <div style="margin-bottom: 10px">
          <el-button style="width: 100px" :plain="true" type="warning" @click.prevent.stop="auditBaseInfo()">审核通过
          </el-button>
        </div>
      </perm>
      <perm :label="'code-goods-autonomously-reject-audit'" v-show="data.orgAuditStatus==='0'">
        <div style="margin-bottom: 10px">
          <el-button style="width: 100px" :plain="true" type="warning" @click.prevent.stop="noPassBaseInfo()">
            审核不通过
          </el-button>
        </div>
      </perm>
      <el-button plain @click="$emit('right-close')">关闭</el-button>
    </template>
    <template slot="content">
      <form-show-part :pageSetsItem="pageSets[0]" :currentTab="currentTab">
        <template slot="content">
          <div>
            <perm :label="xmlBtnList[0].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('1')" >
                <el-button @click="xmlBtnList[0].click(data.id)" type="primary">{{xmlBtnList[0].label}}</el-button>
              </div>
            </perm>

            <perm :label="xmlBtnList[1].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('2')">
                <el-button @click="xmlBtnList[1].click(data.id)" type="primary">{{xmlBtnList[1].label}}</el-button>
              </div>
            </perm>

            <perm :label="xmlBtnList[2].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('7')">
                <el-button @click="xmlBtnList[2].click(data.id)" type="primary">{{xmlBtnList[2].label}}</el-button>
              </div>
            </perm>

            <perm :label="xmlBtnList[3].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList
              && (data.orgRelationTypeList.includes('1') || data.orgRelationTypeList.includes('3'))">
                <el-button @click="xmlBtnList[3].click(data.id)" type="primary">{{xmlBtnList[3].label}}</el-button>
              </div>
            </perm>

            <perm :label="xmlBtnList[4].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('5')">
                <el-button @click="xmlBtnList[4].click(data.id)" type="primary">{{xmlBtnList[4].label}}</el-button>
              </div>
            </perm>


            <perm :label="xmlBtnList[7].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('8')">
                <el-button @click="xmlBtnList[7].click(data.id)" type="primary">{{xmlBtnList[7].label}}</el-button>
              </div>
            </perm>

            <perm :label="xmlBtnList[8].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('10')">
                <el-button @click="xmlBtnList[8].click(data.id)" type="primary">{{xmlBtnList[8].label}}</el-button>
              </div>
            </perm>

            <perm :label="xmlBtnList[9].perm">
              <div class="mb-10" v-if="data.orgRelationTypeList && data.orgRelationTypeList.includes('9')">
                <el-button @click="xmlBtnList[9].click(data.id)" type="primary">{{xmlBtnList[9].label}}</el-button>
              </div>
            </perm>
          </div>
          <oms-row :span="5" label="审核不通过原因" v-if="data.rejectReason && data.orgAuditStatus === '2'">
            <span style="color: red"> {{data.rejectReason}}</span>
          </oms-row>
          <el-row>
            <el-col :span="12">
              <oms-row :label=" orgTitle +'分类' ">
              <span v-for="(relationType,index) in data.orgRelationTypeList">
                  {{formatRelationType(relationType)}}
                  <span v-if="(data.orgRelationTypeList.length-1)!==index">/</span>
              </span>
              </oms-row>
              <oms-row label="国家或地区（中文）"   v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">
                {{ data.countryOrRegionChinese }}</oms-row>
              <oms-row label="系统代码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">{{ data.manufacturerCode }}</oms-row>
              <oms-row label="统一社会信用代码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,12])">{{ data.creditCode }}</oms-row>
              <oms-row :label=" orgTitle +'名称' " v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">{{ data.name }}</oms-row>
              <oms-row :label=" orgTitle +'曾用名' "v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">{{ data.orgUsedName }}</oms-row>
              <oms-row label="营业执照单位类型" v-if="showField([1,0,3,0,5,6,7,0,9,0,0,12])">{{data.orgKind}}</oms-row>
              <oms-row label="所在地区" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ companyAddress }}</oms-row>
              <oms-row label="乡(镇/街道办事处)" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.orgTowns }}</oms-row>
              <oms-row label="村(街/路/弄等)" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.orgVillage }}</oms-row>
              <oms-row label="门牌号码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.houseNumber }}</oms-row>
              <oms-row label="住所地址" v-if="showField([1,0,3,0,5,6,7,8,0,10,11,12])">{{ data.address }}</oms-row>
              <oms-row label="国家或地区（英文）" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.countryOrRegionEnglish }}</oms-row>
              <oms-row label="公司名称(中文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyChineseName }}</oms-row>
              <oms-row label="公司名称(英文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyEnglishName }}</oms-row>
              <oms-row label="公司地址(中文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyChineseAddress }}</oms-row>
              <oms-row label="公司地址(英文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">{{ data.companyEnglishAddress }}</oms-row>
              <oms-row label="法定代表人 /机构负责人" v-if="showField([1,0,3,0,5,6,7,8,9,10,0,0])">{{ data.legalRepresentative }}</oms-row>
              <oms-row label="注册资本" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.registeredCapital}}</oms-row>
              <oms-row label="成立日期" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.establishDate | date}}</oms-row>
              <oms-row label="营业期限" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,12])">{{ data.businessTerm | date}}</oms-row>
              <oms-row label="营业执照经营范围" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.businessLicenseScope}}</oms-row>
              <oms-row label="登记机关" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">{{ data.registrationAuthority}}</oms-row>
              <oms-row label="固定电话号码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.fixedLineTelephone }}</oms-row>
              <oms-row label="传真号码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.faxNumber }}</oms-row>
              <oms-row label="电子信箱" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.electronicMail }}</oms-row>
              <oms-row label="企业网址" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.companyWebsite }}</oms-row>
              <oms-row label="联系人" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.contact }}</oms-row>
              <oms-row label="联系电话" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">{{ data.phone }}</oms-row>
              <oms-row label="邮政编码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">{{ data.postcode }}</oms-row>
              <oms-row label="接种单位编码" v-if="showField([0,0,0,0,0,0,0,0,0,10,0,0])">{{ data.inoculateOrgNo }}</oms-row>
              <oms-row label="创建人">{{ data.createdUser }}</oms-row>
              <oms-row label="创建单位" >{{ data.createdOrg }}</oms-row>
              <oms-row label="创建时间">{{ data.createTime | time }}</oms-row>
            </el-col>
            <el-col :span="12">

              <oms-row label="注册地址" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.registeredAddress }}</oms-row>
              <oms-row label="企业负责人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.orgPrincipal }}</oms-row>
              <oms-row label="质量负责人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.qualityPrincipal }}</oms-row>
              <oms-row label="许可证有效期" v-if="showField([1,0,3,0,5,6,0,0,0,0,11,0])">{{ data.licenceValidity | date}}</oms-row>
              <oms-row label="日常监督管理机构" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.supervisionOrg }}</oms-row>
              <oms-row label="投诉举报电话" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.complaintsHotline }}</oms-row>
              <oms-row label="许可证编号" v-if="showField([1,0,3,0,5,6,0,0,0,0,11,0])">{{ data.licenceCode }}</oms-row>
              <oms-row label="分类码" v-if="showField([1,0,0,0,0,0,0,0,0,0,0,0])">{{ data.classifyCode }}</oms-row>
              <oms-row label="生产地址" v-if="showField([1,0,3,0,0,0,0,0,0,0,0,0])">{{ data.productionAddress }}</oms-row>
              <oms-row label="许可证生产范围" v-if="showField([1,0,3,0,0,0,0,0,0,0,0,0])">{{ data.licenceProductionScope }}</oms-row>
              <oms-row label="经营方式" v-if="showField([0,0,0,0,5,6,0,0,0,0,0,0])">{{ data.manageMode }}</oms-row>
              <oms-row label="仓库地址" v-if="showField([0,0,0,0,5,6,0,0,9,0,0,0])">{{ data.warehouseAddress }}</oms-row>
              <oms-row label="许可证经营范围" v-if="showField([0,0,0,0,5,6,0,0,0,0,0,0])">{{ data.licenceManageScope }}</oms-row>
              <oms-row label="发证机关" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.certifyingAuthority }}</oms-row>
              <oms-row label="签发人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.signIssuePerson }}</oms-row>
              <oms-row label="签发日期" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">{{ data.signIssueDate | date}}</oms-row>
              <oms-row label="卫生机构代码" v-if="showField([0,0,0,0,0,0,0,0,0,0,11,0])">{{ data.healthAgencyCode }}</oms-row>
              <oms-row label="药品使用单位类型" v-if="showField([0,0,0,0,0,0,0,0,0,0,11,0])">
                <dict :dict-group="'ypOrgRelationType'" :dict-key="data.drugUserOrgType"></dict>
              </oms-row>
              <oms-row label="厂家备案凭证号" v-if="showField([0,0,3,0,0,6,0,0,0,0,0,0])">{{ data.factoryRecordNumber }}</oms-row>
            </el-col>
            <el-row>
              <el-col :span="12">
              </el-col>
              <el-col :span="12">
              </el-col>
            </el-row>
          </el-row>
        </template>
      </form-show-part>
      <form-show-part :pageSetsItem="pageSets[1]" :currentTab="currentTab">
        <template slot="content">
          <div class="base-box">
            <div v-if="licenses.length === 0" class="empty-info">
              暂无信息
            </div>
            <div v-else>
              <div class="base-pic-list">
                <div v-for=" licence in licenses" class="base-pic-item">
                  <div @click="watchPhoto(licence)">
                    <compressed-img :src="licence.photoThumb+'?image&action=resize:w_180,h_180,m_2'"/>
                    <h3>
                      <el-tooltip class="item" effect="dark" :content="licence.name" placement="top">
                        <span>{{licence.name}}</span>
                      </el-tooltip>
                    </h3>
                    <div>
                      <span>编号: {{licence.licenceNumber}}</span>
                    </div>
                    <div>
                      有效期:
                      <div> {{licence.validStartTime | date}} 至 {{licence.validEndTime |
                        date}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </form-show-part>
    </template>
  </dialog-template>
</template>
<script>
import utils from '@/tools/utils';
import {BaseInfo} from "@/resources";

  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
      licenses: Array,
      show: Boolean,
      orgTitle: {
        type: String,
        default: '单位'
      },
      formatRelationType:Function
    },
    data() {
      return {
        pageSets: [
          {name: '基本信息', key: 0},
          {name: '单位证照', key: 1}
        ],
        currentTab: {}
      }
    },
    computed: {
      companyAddress() {
        let province = this.data.province;
        let city = this.data.city;
        let region = this.data.region;
        return utils.formatAddress(province, city, region);
      }
    },
    filters: {
      isScanCode: function (value) {
        return value ? '扫码' : '不扫码';
      }
    },
    methods: {
      noPassBaseInfo() {
        this.$prompt('', '审核不通过', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入审核不通过原因',
          inputValidator: val => {
            if (!val) return '请输入原因';
            return true;
          }
        }).then(({value}) => {
          BaseInfo.noPassBaseInfo(this.data.id, {status: '2', rejectReason: value}).then(res => {
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '审核完成'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '审核不通过失败'
            });
          });
        }).catch(() => {

        });
      },
      auditBaseInfo() {
        this.$confirm('确认审核通过"' + this.data.name + '"的基础信息、单位证照和经营范围等信息?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BaseInfo.auditBaseInfo(this.data.id, {status: '1'}).then(res => {
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '审核"' + this.data.name + '"的基础信息、单位证照和经营范围等信息成功'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '审核"' + this.data.name + '"的基础信息、单位证照和经营范围等信息失败'
            });
          });
        }).catch(() => {

        });
      },
      showField(arr) {
        if (!this.data || !this.data.orgRelationTypeList) return false;
        return this.data.orgRelationTypeList.some(s => arr.some(a => (a + '') === s));
      },
      selectTab(item) {
        this.currentTab = item;
      },
      watchPhoto(item) {
        if (item.photos.length > 0) {
          this.$store.commit('changeAttachment', {
            currentId: item.photos[0].attachmentId,
            attachmentList: item.photos
          });
        }
      },
    }
  };
</script>
